// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/stylus-loader/index.js??ref--2-2!../../../node_modules/string-replace-loader/index.js??ref--3!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CustomNotifications.vue?vue&type=style&index=0&id=4c64d654&scoped=true&lang=stylus&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("7184e54c", content, true, {});